import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const FullScreenProgressBar = ({ className, stepIndex, totalSteps })=>{
    const lastStepIndex = totalSteps - 1;
    const progress = stepIndex / lastStepIndex * 100;
    return jsx("div", {
        className: classNames('cb-fullscreen-progress-bar', className),
        children: jsx("div", {
            "aria-valuemax": 100,
            "aria-valuemin": 0,
            "aria-valuenow": progress,
            className: classNames('bar'),
            role: "progressbar",
            style: {
                width: `${progress}%`
            }
        })
    });
};
FullScreenProgressBar.displayName = 'FullScreen.ProgressBar';

export { FullScreenProgressBar, FullScreenProgressBar as default };
//# sourceMappingURL=FullScreen.ProgressBar.es.js.map
